import {themeOptions as baseTheme} from './index';
import {createTheme} from '@material-ui/core';

const {colors} = baseTheme;
const basePalette = baseTheme.palette;

const palette = {
  ...basePalette,
  primary: {
    main: colors.purple,
    light: '#c595e1',
    contrastText: '#ffffff'
  }
};

const themeOptions = {
  ...baseTheme,
  palette
};

export default createTheme(themeOptions);
